module.exports = __webpack_public_path__ + "img/spid-ico-circle-bb.cef6c19b.svg";